interface FormattedDateTime {
  formattedDate: string;
  formattedTime: string;
}

export const formatDateAndTime = (isoString: string): FormattedDateTime => {
  const date = new Date(isoString);

  const formattedDate = date.toLocaleDateString('en-US', { timeZone: 'UTC' });

  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  });

  return { formattedDate, formattedTime };
};
